<div class="d-flex flex-column flex-md-row align-items-center justify-content-between w-100">
<!--  <div class="mx-4">-->
<!--    <img alt="logo-wok" width="190" src="../../../../assets/images/logo-header-261x44.png">-->
<!--  </div>-->
<!--  - -->
  <div class="mx-4">
    <small>Last build at: {{lastBuildTime}}</small>
  </div>
</div>
